import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { TranslateService } from '@ngx-translate/core';
import { InsideType } from '../../models/inside-type';
import { InsideTypeService } from '../../services/inside-type.service';

@Component({
  selector: 'app-inside-type-edit',
  templateUrl: './inside-type-edit.component.html',
  styleUrls: ['./inside-type-edit.component.css']
})
export class InsideTypeEditComponent extends EditForm<InsideType> implements OnInit {

  constructor(
    ns: ToastrService,          
    tr:TranslateService,
    r: Router,
    ds:InsideTypeService,
    ar: ActivatedRoute,
    l:Location,        
  ) { 
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/inside-type');
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      picture: new FormControl()
    });
    super.ngOnInit();    
  }
  onFileUpload(file:IFileStoreItem){
    if(file){
      this.form.controls['picture'].setValue(file.id);
    }
    else {
      this.form.controls['picture'].setValue(null);
    }
  }

}